import { ChatTraceData } from '../chat-model.interface';

export enum ChatEngineOperations {
  OPEN_ACTIVE_CONVERSATION = 'Open active conversation',
  SEND_MESSAGE_IN_ACTIVE_CONVERSATION = 'Send message in active conversation',
  SEND_MESSAGE_TO_PROFILE = 'Send message to profile',
  SEND_MESSAGE_NEW_DIALOG = 'Send message from a new conversation dialog',
  LOAD_MORE_MESSAGES = 'Load more messages in active channel',
  EDIT_MESSAGE = 'Edit message in active conversation',
  REMOVE_MESSAGE = 'Remove message from active conversation',
  MARK_ALL_MESSAGES_AS_CONSUMED = 'Mark all messages as consumed',
  DISMISS_NOTIFICATION = 'Dismiss notification message',
  BLOCK_USER = 'Block user',
  UNBLOCK_USER = 'Unblock user',
}

export abstract class ChatEngineErrorService {
  public abstract onOperationFailed(operationName: string, error: unknown, traceData: ChatTraceData): void;
}
